export default __webpack_public_path__ + "static/media/icons-system-info.f3c334b1.svg";